
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ui/sonner";
import { Button } from "@/components/ui/button";
import PageLayout from "@/layouts/PageLayout";
import { BackgroundGradient } from "@/components/ui/background-gradient";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    toast("Message received. We'll be in touch soon!");
    setFormData({ name: "", email: "", message: "" });
    setLoading(false);
  };

  return (
    <PageLayout pageTitle="cheqbooq">
      <BackgroundGradient className="py-16 px-6 flex-grow" variant="subtle">
        <div className="max-w-3xl mx-auto">
          <h1 className="premium-title mb-8">Contact Us</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <p className="premium-body mb-6">
                Have questions about cheqbooq or want to know more about our movement? 
                Get in touch with our team.
              </p>
              
              <div className="space-y-4 mt-8">
                <div>
                  <h3 className="text-lg font-medium">Email</h3>
                  <p className="premium-body">hello@cheqbooq.com</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-medium">Location</h3>
                  <p className="premium-body">Saskatoon, SK, Canada</p>
                </div>
                
                <div className="pt-4">
                  <h3 className="text-lg font-medium">Follow Us</h3>
                  <div className="flex space-x-4 mt-2">
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors text-sm">Twitter</a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors text-sm">LinkedIn</a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors text-sm">Instagram</a>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium mb-1">
                    Name
                  </label>
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium mb-1">
                    Email
                  </label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium mb-1">
                    Message
                  </label>
                  <Textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="text-sm"
                  />
                </div>
                
                <Button 
                  type="submit" 
                  className="w-full"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </BackgroundGradient>
    </PageLayout>
  );
};

export default ContactPage;
